import { Typography } from '@mui/material';

const LabeledValue = ({ label = '', value = '' }) => {
  return (
    <>
      <Typography color="text.primary" component="span" sx={{ mr: '.5rem', fontWeight: 'bold' }}>
        {label}:
      </Typography>
      <Typography component="span">{value}</Typography>
    </>
  );
};

export default LabeledValue;
